import Cookies from 'js-cookie';

function utmKDetect(itemSpecInfo) {
  return null;
}

function shareCode() {
  let USCValue = '';

  if (Cookies.get('U_SC')) {
    USCValue = Cookies.get('U_SC');
  }

  return USCValue || null;
}

function useUtmKDetect() {
  return { utmKDetect, shareCode };
}

export default useUtmKDetect;
